<template>
  <div class="response">
    <div style="width: 55%; margin: 0px 3%; text-align: left">
      <sortRight></sortRight>
      <codeRight
        :str="str"
        :pythonStr="pythonStr"
        :jsStr="jsStr"
        :goStr="goStr"
        :javaStr="javaStr"
        :ellStr="ellStr"
        :sllStr="sllStr"
        :slyStr="slyStr"
        :slsStr="slsStr"
        :srjStr="srjStr"
        :wlsStr="wlsStr"
        :wlfStr="wlfStr"
        style="
          position: absolute;
          top: 24px;
          right: 20px;
          width: 450px;
          display: flex;
          flex-direction: column;
          height: calc(100vh - 231px);
        "
      ></codeRight>
    </div>
    <!-- <div style="width:450px">
       
          </div> -->
  </div>
</template>
  <script>
import sortRight from "./sortRight.vue";
import codeRight from "./codeRight.vue";
import hljs from "highlight.js";
import "highlight.js/styles/vs2015.css"; // 黑色主题样式
export default {
  name: "Home",
  components: {
    sortRight,
    codeRight,
  },
  data() {
    return {
      str: `curl --request POST \
  --url ${this.$codeUrl}v1/rerank \
  --header 'Authorization: Bearer <token>' \
  --header 'Content-Type: application/json' \
  --data '{
  "model": "BAAI/bge-reranker-v2-m3",
  "query": "Apple",
  "documents": [
    "apple",
    "banana",
    "fruit",
    "vegetable"
  ],
  "top_n": 4,
  "return_documents": false,
  "max_chunks_per_doc": 1024,
  "overlap_tokens": 80
}''`.trim(),
      jsStr: `const options = {
  method: 'POST',
  headers: {Authorization: 'Bearer <token>', 'Content-Type': 'application/json'},
  body: '{"model":"BAAI/bge-reranker-v2-m3","query":"Apple","documents":["apple","banana","fruit","vegetable"],"top_n":4,"return_documents":false,"max_chunks_per_doc":1024,"overlap_tokens":80}'
};

fetch('${this.$codeUrl}v1/rerank', options)
  .then(response => response.json())
  .then(response => console.log(response))
  .catch(err => console.error(err));`.trim(),
      goStr: `package main

import (
	"fmt"
	"strings"
	"net/http"
	"io/ioutil"
)

func main() {

	url := "${this.$codeUrl}v1/rerank"

	payload := strings.NewReader("{\n  \"model\": \"BAAI/bge-reranker-v2-m3\",\n  \"query\": \"Apple\",\n  \"documents\": [\n    \"apple\",\n    \"banana\",\n    \"fruit\",\n    \"vegetable\"\n  ],\n  \"top_n\": 4,\n  \"return_documents\": false,\n  \"max_chunks_per_doc\": 1024,\n  \"overlap_tokens\": 80\n}")

	req, _ := http.NewRequest("POST", url, payload)

	req.Header.Add("Authorization", "Bearer <token>")
	req.Header.Add("Content-Type", "application/json")

	res, _ := http.DefaultClient.Do(req)

	defer res.Body.Close()
	body, _ := ioutil.ReadAll(res.Body)

	fmt.Println(res)
	fmt.Println(string(body))

}`.trim(),
      javaStr:
        `HttpResponse<String> response = Unirest.post("${this.$codeUrl}v1/rerank")
  .header("Authorization", "Bearer <token>")
  .header("Content-Type", "application/json")
  .body("{\n  \"model\": \"BAAI/bge-reranker-v2-m3\",\n  \"query\": \"Apple\",\n  \"documents\": [\n    \"apple\",\n    \"banana\",\n    \"fruit\",\n    \"vegetable\"\n  ],\n  \"top_n\": 4,\n  \"return_documents\": false,\n  \"max_chunks_per_doc\": 1024,\n  \"overlap_tokens\": 80\n}")
  .asString();`.trim(),
  ellStr:`
  {
  "id": "<string>",
  "results": [
    {
      "document": {
        "text": "<string>"
      },
      "index": 123,
      "relevance_score": 123
    }
  ],
  "tokens": {
    "input_tokens": 123,
    "output_tokens": 123
  }
}`.trim(),
      sllStr: `{
  "code": 20012,
  "message": "<string>",
  "data": "<string>"
}`.trim(),
      slyStr: `"Invalid token"`.trim(),
      slsStr: `"404 page not found"`.trim(),
      srjStr: `{
    "message": "Request was rejected due to rate limiting. If you want more, please contact contact@siliconflow.cn. Details:TPM limit reached.",
    "data": "<string>"
  }`.trim(),
      wlsStr: `{
    "code": 50505,
    "message": "Model service overloaded. Please try again later.",
    "data": "<string>"
  }`.trim(),
      wlfStr: `"<string>"`.trim(),

      pythonStr: `import requests

url = "${this.$codeUrl}v1/rerank"

payload = {
    "model": "BAAI/bge-reranker-v2-m3",
    "query": "Apple",
    "documents": ["apple", "banana", "fruit", "vegetable"],
    "top_n": 4,
    "return_documents": False,
    "max_chunks_per_doc": 1024,
    "overlap_tokens": 80
}
headers = {
    "Authorization": "Bearer <token>",
    "Content-Type": "application/json"
}

response = requests.request("POST", url, json=payload, headers=headers)

print(response.text)`.trim(),
    };
  },
};
</script>
  <style scoped>
.response {
  width: 100%;
  height: 100%;
  display: flex;
  padding-left: 250px;
  height: calc(100vh - 189px);
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
  overflow: auto;
  /* position: relative; */
}
.response::-webkit-scrollbar {
  display: none; /* Chrome/Safari/Opera */
}
</style>